import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import ServiceInner from '../Components/Services/ServiceInner'
import TourTwo from '../Components/Tour/TourTwo'
import PricingPlan from '../Components/Services/PricingPlan'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import OfferTwo from '../Components/Offer/OfferTwo'
import WhatsAppButton from '../Components/WA button/WAbutton';

import TestimonialThree from '../Components/Testimonials/TestimonialThree'
    


function GlobalVisa() {
    return (
        <div>
            <HeaderOne />
            <Breadcrumb
                title="Global Visa"
            />
            <ServiceInner />
            {/* <OfferTwo /> */}

            {/* <TourTwo /> */}
            <TestimonialThree />

            <FooterFour />  
            <WhatsAppButton phone="971561678861" />

            <ScrollToTop />
        </div>
    )
}

export default GlobalVisa

